<form id="msform">
	<!-- pasos top -->
	<ul id="progressbar_pasos">
		<li *ngFor="let item of steps; let i = index" [ngClass]="{ active_paso: i <= currentStep }">
			<div class="icon_step"><img [src]="item.pathImage" /></div>
			<strong>{{ item.title }} </strong>
		</li>
	</ul>
	<!-- Fin pasos top -->

	<fieldset>
		<ng-content select="[step1]" *ngIf="currentStep + 1 === 1"></ng-content>
		<ng-content select="[step2]" *ngIf="currentStep + 1 === 2"></ng-content>
		<ng-content select="[step3]" *ngIf="currentStep + 1 === 3"></ng-content>
		<ng-content select="[step4]" *ngIf="currentStep + 1 === 4"></ng-content>

		<ng-container *ngIf="currentStep < steps.length - 1">
			<button *ngIf="currentStep > 0" type="button" name="previous" class="previous_paso" (click)="back()">
				ANTERIOR
			</button>
			<button
				type="button"
				name="next"
				class="next_paso"
				(click)="next()"
				[ngClass]="{ btn_conf: currentStep + 1 === steps.length - 1 }"
			>
				{{
					currentStep + 1 === steps.length - 1
						? textButtonSuccess
						: currentStep === 0
						? 'GUARDAR'
						: currentStep === 1
						? 'CONFIRMAR'
						: 'CONFIRMAR'
				}}
			</button>
		</ng-container>

		<ng-container *ngIf="showBack && currentStep + 1 === steps.length">
			<button type="button" name="close" class="button btn_regresar" (click)="closeModal()">REGRESAR</button>
		</ng-container>
		<div class="content_alerts alerta_confirmacion" *ngIf="messageTransfer && currentStep === 0">
			<div class="alert alert_info">
				<span><img src="assets/images/alert_info.png" alt="info" /></span>
				<div class="info_bancos" [innerHtml]="messageTransfer"></div>
			</div>
		</div>
	</fieldset>
</form>
